import actions from './actions';
import axios from '../axios';
import store from '../store';
import { message } from 'antd';
import errorHandling from '../error';
import Cookies from 'js-cookie';

const {
  getBlogCategoryBegin, getBlogCategorySuccess, getBlogCategoryFailed,
  addBlogCategoryBegin, addBlogCategorySuccess, addBlogCategoryFailed,
  updateBlogCategoryBegin, updateBlogCategorySuccess, updateBlogCategoryFailed,
  deleteBlogCategoryBegin, deleteBlogCategorySuccess, deleteBlogCategoryFailed,
} = actions;

// GETTING ALL BLOG-CATEGORIES
export const getAllBlogCategories = async (dispatch) => {
  try {
    dispatch(getBlogCategoryBegin());
    const res = await axios.get('blog-categories', { headers: { 'Authorization': `Bearer ${Cookies.get('authToken')}` } });
    dispatch(getBlogCategorySuccess(res.data.categories));
  } catch (err) {
    dispatch(getBlogCategoryFailed(err?.response?.data?.msg));
    dispatch(errorHandling(err, false))
  }
}

// ADDING NEW BLOG CATEGORY
export const addNewBlogCategory = (data, form) => async (dispatch) => {
  try {
    const state = store.getState();
    dispatch(addBlogCategoryBegin());
    const res = await axios.post('blog-categories', data, { headers: { 'Authorization': `Bearer ${Cookies.get('authToken')}` } });

    dispatch(addBlogCategorySuccess([res.data.category, ...state.blogCategory.categories]));
    message.success('New blog category created successfully');
    form.resetFields();
  } catch (err) {
    dispatch(addBlogCategoryFailed(err?.message));
    dispatch(errorHandling(err))
  }
}

// UPDATING BLOG CATEGORY
export const editBlogCategory = (id, datas) => async (dispatch) => {
  try {
    const state = store.getState();
    dispatch(updateBlogCategoryBegin());
    const res = await axios.put(`blog-categories/${id}`, datas, { headers: { 'Authorization': `Bearer ${Cookies.get('authToken')}` } });
    const newBlogCategories = state.blogCategory.categories.map(category => {
      if (category._id === id) return res.data.category;
      else return category;
    })
    dispatch(updateBlogCategorySuccess(newBlogCategories));
    message.success('Blog category updated successfully')
  } catch (err) {
    dispatch(updateBlogCategoryFailed(err?.response?.data?.msg));
    dispatch(errorHandling(err))
  }
}

// DELETE BLOG CATEGORY
export const deleteBlogCategory = id => async (dispatch) => {
  try {
    const state = store.getState();
    dispatch(deleteBlogCategoryBegin());
    await axios.delete(`blog-categories/${id}`, { headers: { 'Authorization': `Bearer ${Cookies.get('authToken')}` } });

    dispatch(deleteBlogCategorySuccess(state.blogCategory.categories.filter(category => category._id !== id)));
    message.success('Blog category deleted successfully')
  } catch (err) {
    dispatch(deleteBlogCategoryFailed(err?.response?.data?.msg));
    dispatch(errorHandling(err))
  }
} 